import React, { useState } from 'react';
import useAuth from './hooks/useAuth';
import { useNavigate } from "react-router-dom";
import Profile from './Profile'
import './Contact.css';


function Contact() {
    const { auth, setAuth } = useAuth();
    let navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyWebsite, setCompanyWebsite] = useState("");
    const [dataRequirements, setDataRequirements] = useState("all");
    const [additionalDetails, setAdditionalDetails] = useState("");

    const cancelAction = () => {
        navigate("/Pricing");
    }
    return (
        <div style={{ textAlign: "left", padding:"160px 310px 110px 310px"}}>
            <div style={{padding:"10px 20px 60px 20px", backgroundColor:"#FFF", borderRadius:"15px"}}>
                <div><h2>Looking for Custom API Solutions?</h2></div>
                <div>
                    <p>If you need a tailored API, advanced data integration, data redistribution options, priority support, or have any other specific requirements, we're here to help!.</p>
                    <p>Simply fill out the form below, and out team will get back to you promptly to discuss your needs and explore how we can support your goals.</p>
                    <p>We look forward to collaborating with you to diliver the perfect solution.</p>
                </div>
                <div style={{ boxShadow: "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px", paddingTop:"20px"}}>
                    <div style={{textAlign:"center", fontSize:"20px", fontWeight:"600"}}>Send your enquiry to our enterprise team</div>
                    <div style={{ lineHeight: "1.8", display: "grid", gridTemplateColumns: "47% 47%", gap: "20px", rowGap: "10px", padding: "20px" }}>
                        <div><div>Email<span>*</span></div><div><input type="text" className="designedInput" value={email} onChange={(e) => setEmail(e.target.value)} /></div></div>
                        <div><div>Contact Number</div><div><input type="text" className="designedInput" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} /></div></div>
                        <div><div>First Name<span>*</span></div><div><input type="text" className="designedInput" value={firstName} onChange={(e) => setFirstName(e.target.value)} /></div></div>
                        <div><div>Last Name<span>*</span></div><div><input type="text" className="designedInput" value={lastName} onChange={(e) => setLastName(e.target.value)} /></div></div>
                        <div><div>Company Name<span>*</span></div><div><input type="text" className="designedInput" value={companyName} onChange={(e) => setCompanyName(e.target.value)} /></div></div>
                        <div><div>Company Website<span>*</span></div><div><input type="text" className="designedInput" value={companyWebsite} onChange={(e) => setCompanyWebsite(e.target.value)} /></div></div>
                    </div>
                    <div style={{padding:"0px 20px"}}>
                        <div style={{ width: "97%" }}>Data Requirements & Usage Specifications<span>*</span></div>
                        <div style={{ width: "97%", paddingTop: "5px" }}>
                            <select style={{width:"100%"}} type="text" className="designedInput" value={dataRequirements} onChange={(e) => setDataRequirements(e.target.value)} >
                                <option value="all">All</option>
                                <option value="fundamentals">Fundamentals</option>
                                <option value="market">Market</option>
                                <option value="shareholding">Shareholding</option>
                                <option value="commodity">Commodity</option>
                            </select>
                        </div>
                    </div>
                    <div style={{ padding: "20px" }}>
                        <div style={{width:"97%"}}>Additional Details<span>*</span></div>
                        <div style={{ width: "93%", paddingTop: "5px"  }}>
                            <textarea style={{ width: "100%" }} className="designedInput" rows="3" cols="180" value={additionalDetails} onChange={(e) => setAdditionalDetails(e.target.value)} >
                            </textarea>
                        </div>
                    </div>

                    <div style={{ padding: "20px" }}>
                        <div style={{ backgroundColor: "blue", color: "white", padding: "10px", textAlign: "center", width: "95%", borderRadius:"5px", cursor:"pointer"}}>Send</div>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div>

        </div>
    );
}
export default Contact;